(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDialogController', FrequentlyAskedQuestionDialogController);

    FrequentlyAskedQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FrequentlyAskedQuestion', 'CustomUser', 'Comment', 'Task', 'ProfessionalArea', 'Answer'];

    function FrequentlyAskedQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FrequentlyAskedQuestion, CustomUser, Comment, Task, ProfessionalArea, Answer) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.comments = Comment.query();
        vm.tasks = Task.query();
        vm.professionalareas = ProfessionalArea.query();
        vm.answers = Answer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequentlyAskedQuestion.id !== null) {
                FrequentlyAskedQuestion.update(vm.frequentlyAskedQuestion, onSaveSuccess, onSaveError);
            } else {
                FrequentlyAskedQuestion.save(vm.frequentlyAskedQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:frequentlyAskedQuestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationTime = false;
        vm.datePickerOpenStatus.updateTime = false;
        vm.datePickerOpenStatus.revisionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
